export const validatePhoneNumber = (value) => {
    if (value && parseInt(value) > 6000000000 && parseInt(value) <= 9999999999)
        return true
    else return false
}

export const validateUserName = (name) => {
    if (name && name != '' && name != 'N/a' && !(/\d/.test(name)))
        return true
    else false
}